
<div class="dashboard-content-sec">
    <div class="card mb-0">
        <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <span class="p-2" href="#">
                        {{this.total}} Documents</span>
            </div>
 
            <div style='width: 180px' class="d-inline-block">
                <a  href="javascript:void(0)" [routerLink]="['/admins/document']" 
                    class="btn btn-default fa fa-user-circle">
                    Add Document
                </a>     
            </div>  
          
        </div>

        <div id="contentTable" class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i> {{header.text}}
                        </th>
                      <th>Delete</th>
                    </tr>
                    <tr>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByName($event)" />
                            </div>
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByCategory($event)"/>
                            </div>
                        </th>
                        <th>
                            &nbsp;
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByState($event)"/>
                            </div>
                        </th>
                        <th>
                            &nbsp;
                        </th>
                        <th>
                            &nbsp;
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let document of allDocument">
                        <tr>
                        
                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/document',document.ID]">
                                    {{document.Name}}
                                </a>
                            </td>
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/document',document.ID]">
                                    {{document.Category}}
                                </a>
                            </td>
                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/document',document.ID]">
                                    {{document.HasState == 1 ? 'Yes' : 'No'}}
                                </a>
                            </td>
                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/document',document.ID]">
                                    {{document.State}}
                                </a>
                            </td>
                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/document',document.ID]">
                                    {{document.HasDate == 1 ? 'Yes' : 'No'}}
                                </a>
                            </td>

                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/document',document.ID]">
                                    {{document.RevisionDate}}
                                </a>
                            </td>

                            <td>
                                <div class="d-inline-block">
                                    <a title="Delete" class="btn fa fa-times" (click)="deleteDocument(document.ID)"> </a>
                                </div>
                            </td>
                        </tr>

                    </ng-container>
                </tbody>

                <ng-container *ngIf="allDocument?.length == 0">
                  <tr><td colspan="4">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
